<template>
  <div class="container">
    <div class="text-with-image-cascade text_spacer">
      <text-with-image-inline
        :title_tag="title_tag"
        :title="title"
        :lazy_img_src="lazy_img_src"
        :img_src="img_src"
        class="text-with-image-cascade__item">
        <div class="row mt-10">
          <div class="col-6">
            <html-block
              :content="content_left"
            />
          </div>
          <div class="col-6">
            <html-block
              :content="content_right"
            />
          </div>
        </div>
      </text-with-image-inline>
    </div>
  </div>
</template>

<script>
import TextWithImageInline from "../parts/builder/TextWithImageInline.vue";
import HtmlBlock from "../small_parts/HtmlBlock.vue";

export default {
  name: "TextTwoColumnsWithImage",
  components: {
    HtmlBlock,
    TextWithImageInline
  },
  props: {
    /**props**/
    img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    title_tag: {
      type: String,
      default: 'h1',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    content_left: {
      type: String,
      default: '',
      required: true,
      admin_type: 'editor',
    },
    content_right: {
      type: String,
      default: '',
      required: true,
      admin_type: 'editor',
    },
    /**props**/
  },
}
</script>
